import {request} from '../utils/request'

const guide = {
    // 获取试卷列表
    getUserGuideList:function(data) {
        return request({
            method: "POST",
            url: "/api/guide/guideService/getUserGuideList",
            data
        });
    },
    // 新手引导不再显示
    insertUserGuideLog:function(data) {
      return request({
        method: "POST",
        url: "/api/guide/guideService/insertUserGuideLog",
        data
      });
    },
}

export default guide;
